import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";
import Single from "./pages/single/Single";
import New from "./pages/new/New";
import Profile from "./pages/profile/Profile";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { productInputs, userInputs } from "./formSource";
import "./style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import RequireAuth from "./RequireAuth"
//import { AuthContext } from "./context/AuthContext";

function App() {
  const { darkMode } = useContext(DarkModeContext);

  //const {currentUser} = useContext(AuthContext)


  return (
    <div className={darkMode ? "app dark" : "app"}>
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route path="login" element={<Login />} />
            <Route
              index
              element={
                <RequireAuth>
                  <Home />
                </RequireAuth>
              }
            />
            <Route path="/list" >
              <Route
                path="images"
                element={
                  <RequireAuth>
                    <List dir='images' />
                  </RequireAuth>
                }
              />
              <Route
                path="documents"
                element={
                  <RequireAuth>
                    <List dir='documents' />
                  </RequireAuth>
                }
              />
              <Route
                path="voicemails"
                element={
                  <RequireAuth>
                    <List dir='voicemails' />
                  </RequireAuth>
                }
              />
              <Route
                path="videos"
                element={
                  <RequireAuth>
                    <List dir='videos' />
                  </RequireAuth>
                }
              />
              <Route
                path="audios"
                element={
                  <RequireAuth>
                    <List dir='audios' />
                  </RequireAuth>
                }
              />
              <Route
                path="contacts"
                element={
                  <RequireAuth>
                    <List dir='contacts' />
                  </RequireAuth>
                }
              />
              <Route
                path="sms"
                element={
                  <RequireAuth>
                    <List dir='sms' />
                  </RequireAuth>
                }
              />

            </Route>


            <Route path="/users" >
              <Route
                index
                element={
                  <RequireAuth>
                    <List title='images' />
                  </RequireAuth>
                }
              />
                            <Route
                path="profile"
                element={
                  <RequireAuth>
                    <Profile />
                  </RequireAuth>
                }
              />
              <Route
                path=":userId"
                element={
                  <RequireAuth>
                    <Single />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <New inputs={userInputs} title="Add New User" />
                  </RequireAuth>
                }
              />
            </Route>
            <Route path="/products">
              <Route
                index
                element={
                  <RequireAuth>
                    <List />
                  </RequireAuth>
                }
              />
              <Route
                path=":productId"
                element={
                  <RequireAuth>
                    <Single />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <New inputs={productInputs} title="Add New Product" />
                  </RequireAuth>
                }
              />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;